module.exports = __webpack_public_path__ + "static/media/ampl-bsc-mp-busd.c2bae62e.svg";